import { css } from '@emotion/react';

export default {
  checkbox: css`
  > div {
    color: white;
  }`
}